// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"191deb4e","732":"b780f1f2","977":"7232b2db"}[chunkId] + ".chunk.js";
};